import React, { useState, useEffect } from "react";
import axiosInstance from "../../../axiosInstance";
import Sidebar from "../Sidebar/Sidebar";
import "./NewsList.css";
import AdsBanner from "../../AdsBanner/AdsBanner";

function NewsList() {
  const [newsList, setNewsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredNews, setFilteredNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false); // Editing mode state
  const [currentNews, setCurrentNews] = useState(null); // Current news being edited
  const [image, setImage] = useState(null); // To store the uploaded image file
  const [previewImage, setPreviewImage] = useState(""); // For displaying the old image

  const ID = localStorage.getItem("reporterId");
  const token = localStorage.getItem("sessiontoken");
  const reporterId = ID;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/news/news-by-reporter?reporterId=${reporterId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.data && Array.isArray(response.data.data)) {
          setNewsList(response.data.data);
          setFilteredNews(response.data.data);
          await fetchTotalViewsForNews(response.data.data);
        } else {
          setNewsList([]);
          setFilteredNews([]);
        }
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchTotalViewsForNews = async (newsItems) => {
      try {
        const updatedNewsList = await Promise.all(
          newsItems.map(async (news) => {
            const response = await axiosInstance.get(
              `/api/news/status/news-total-views?reporterId=${reporterId}&newsId=${news.newsId}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const totalViews = response.data.totalViews || 0;
            return { ...news, viewCount: totalViews };
          })
        );

        setNewsList(updatedNewsList);
        setFilteredNews(updatedNewsList);
      } catch (error) {
        console.error("Error fetching total views:", error);
      }
    };

    fetchNews();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value === "") {
      setFilteredNews(newsList);
    } else {
      const filtered = newsList.filter((news) =>
        news.newsId.toString().includes(e.target.value) ||
        (news.title && news.title.toLowerCase().includes(e.target.value.toLowerCase()))
      );
      setFilteredNews(filtered);
    }
  };

  const handleEditClick = (news) => {
    setIsEditing(true);
    setCurrentNews(news);
    setPreviewImage(news.imageUrl); // Set the preview to the current image
    setImage(null); // Clear the file input state
  };

  const handleFormChange = (e) => {
    setCurrentNews({
      ...currentNews,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", currentNews.title);
      formData.append("shortDescription", currentNews.shortDescription);
      formData.append("description", currentNews.description);
      formData.append("category", currentNews.category);

      // Only append the image if a new one is selected
      if (image) {
        formData.append("image", image);
      }

      await axiosInstance.put(
        `/api/news/edit/${currentNews.newsId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("News updated successfully!");
      setIsEditing(false);
      setCurrentNews(null);

      // Update the news list with the edited news
      const updatedList = newsList.map((news) =>
        news.newsId === currentNews.newsId ? { ...news, ...currentNews, imageUrl: image ? URL.createObjectURL(image) : previewImage } : news
      );
      setNewsList(updatedList);
      setFilteredNews(updatedList);
    } catch (error) {
      console.error("Error updating news:", error);
      alert("Failed to update news. Please try again.");
    }
  };

  // Image handler for the input
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file); // Store the new image
      setPreviewImage(URL.createObjectURL(file)); // Update preview to the new image
    }
  };
  const categories = [
    "breaking-news",
    "live",
    "entertainment",
    "cinema",
    "sports",
    "others"
  ];

  return (
    <div>
      <Sidebar />
      <div className="news-list-main">
        <div className="news-list">
          <AdsBanner placement="Header" page="News" />

          {!isEditing ? (
            <>
              <input
                type="text"
                placeholder="Search by News ID or Title"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />

              <div className="news-cards-container">
                {loading ? (
                  <p>Loading...</p>
                ) : filteredNews.length === 0 ? (
                  <p>No news found with the specified ID or Title.</p>
                ) : (
                  filteredNews.map((news) => (
                    <div key={news._id} className="news-card">
                      <div className="news-card-header">
                        <p className={`status ${news.status ? news.status.toLowerCase() : "unknown"}`}>
                          {news.status || "Unknown"}
                        </p>
                      </div>
                      <div className="news-card-body">
                        <p>{news.title || "No Title Available"}</p>
                        <p>
                          <strong>News ID:</strong> {news.newsId}
                        </p>
                        <p>
                          <strong>Submitted at:</strong>{" "}
                          {new Date(news.createdAt).toLocaleString()}
                        </p>
                        <div className="news-card-footer">
                          <p>
                            <strong>Total Views:</strong> {news.viewCount || 0}
                          </p>
                        </div>
                        {news.status === "rejected" && (
                          <button
                            onClick={() => handleEditClick(news)}
                            className="edit-button"
                          >
                            Edit News
                          </button>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <form onSubmit={handleFormSubmit} className="edit-form">
  <h2>Edit News</h2>
  <label>
    NewsId:
    <input
      type="text"
      name="newsId"
      value={currentNews.newsId || ""}
      readOnly 
    />
  </label>
  <label>
    Title:
    <input
      type="text"
      name="title"
      value={currentNews.title || ""}
      onChange={handleFormChange}
    />
  </label>
  <label>
    Short Description:
    <input
      type="text"
      name="shortDescription"
      value={currentNews.shortDescription || ""}
      onChange={handleFormChange}
    />
  </label>
  <label>
    Description:
    <textarea
      name="description"
      value={currentNews.description || ""}
      onChange={handleFormChange}
    ></textarea>
  </label>
  <label>
    Category:
    <select
      name="category"
      value={currentNews.category || ""}
      onChange={handleFormChange}
    >
      <option value="" disabled>Select Category</option>
      {categories.map((category) => (
        <option key={category} value={category}>
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </option>
      ))}
    </select>
  </label>
  <label>
    Current Image:
    <img src={previewImage} alt="Current" className="current-image-preview" />
  </label>
  <label className="addnews-label">
    Upload New Image:
    <input
      type="file"
      onChange={handleImageChange}
      className="addnews-input"
    />
  </label>
  <button type="submit" className="save-button">Save</button>
  <button
    type="button"
    onClick={() => setIsEditing(false)}
    className="cancel-button"
  >
    Cancel
  </button>
</form>

          )}
        </div>
      </div>
    </div>
  );
}

export default NewsList;
